import React, { useState } from "react";

export function useShareState() {
    const [adminDocumentState, setAdminDocumentState] = useState<Record<string, any>>({});
    const [shareDocumentId, setShareDocumentId] = useState<number>();

    return {
        adminDocumentState,
        setAdminDocumentState,
        shareDocumentId,
        setShareDocumentId
    };
}
